export default __webpack_public_path__ + "static/media/okoli.d9ae8698.webp";